import { IField } from '../config';

export interface IJira {
  email: string;
  api_key: string;
  server_url: string;
  project_key: string;
  is_active: boolean;
}

export const FIELDS: IField[] = [
  {
    label: 'Integration Name',
    field: 'configuration_name',
    errorText: 'At lease 3 characters'
  },
  {
    label: 'JIRA Server Base URL',
    field: 'server_url',
    errorText: 'Invalid URL'
  },
  {
    label: 'JIRA Email',
    field: 'username',
    info: 'This user will open Jira tickets on behalf of IONIX',
    errorText: 'Invalid email'
  },
  {
    label: 'JIRA API Token',
    // isSecure: true,
    field: 'password',
    isPassword: true,
    // info: 'Note that the API key has to be generated using the user/Jira email used for this integration'
    info: 'Password',
    errorText: 'At lease 3 characters'
  },
  {
    label: 'JIRA Project Key',
    field: 'project',
    errorText: 'At lease 2 characters'
  }
];
